/* eslint-disable spire/export-styles */

import React, { FC } from "react";
import { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

type Props = WidgetProps;

export interface CategoryDetailsContainerStyles {
    container?: InjectableCss;
    categoryDetailsList?: InjectableCss;
    categoryDetailsSubCategory?: InjectableCss;
}

const styles: CategoryDetailsContainerStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            padding: 5px;
            padding-left: 0;
            max-width: 100%;
            & .categoryTitle {
                margin-bottom: 15px !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: block;
                            & .categoryTitle {
                                display: none;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    categoryDetailsList: {
        css: css`
            flex-basis: 25%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin-bottom: 30px;
                            display: none;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    categoryDetailsSubCategory: {
        css: css`
            flex-basis: 75%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-basis: 100%;
                            max-width: 100%;
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
};

export const categoryDetailsContainerStyles = styles;

const CategoryDetailsContainer: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} className="CategoryDetailcontainer">
            <StyledWrapper {...styles.categoryDetailsList}>
                <Zone contentId={id} zoneName="categoryDetailsList" />
            </StyledWrapper>
            <StyledWrapper {...styles.categoryDetailsSubCategory}>
                <Zone contentId={id} zoneName="categoryDetailsSubCategory" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const categoryDetailsContainer: WidgetModule = {
    component: CategoryDetailsContainer,
    definition: {
        group: "Common",
    },
};

export default categoryDetailsContainer;
